import { LoggerAnalyticsAdapter, SegmentAnalyticsAdapter, analyticsAdapter } from '@nx/analytics-service';
import { isNonEmptyString } from '@nx/stdlib';

import { createAsyncThunk } from '../../context';
import { selectNetworkPolicies } from '../../selectors';
import { selectSegmentConfiguration } from '../../slices/configuration/configuration-slice';
import { segmentDbCoreFieldsInjectionPlugin } from './segment-db-core-fields-plugin';

async function setupAnalyticsAdapter(
  eventPrefix?: string,
  apiKey?: string,
  mixpanelConfig?: { projectToken: string; recordSessionsPercent?: number; useSimplifiedIdMerge?: boolean },
) {
  if (apiKey === undefined) {
    await analyticsAdapter.setup(new LoggerAnalyticsAdapter());
  } else {
    const segmentAnalyticsAdapter = new SegmentAnalyticsAdapter({
      apiKey,
      eventPrefix,
      mixpanel: mixpanelConfig,
    });
    segmentAnalyticsAdapter.addPlugin(segmentDbCoreFieldsInjectionPlugin);

    await analyticsAdapter.setup(segmentAnalyticsAdapter);
  }
}

export const setupIfAllowed = createAsyncThunk('analytics/setupIfAllowed', async (_, { getState }) => {
  const state = getState();
  const networkPolicies = selectNetworkPolicies(state);
  const configuration = selectSegmentConfiguration(state);

  if (networkPolicies.usageTrackingAllowed && configuration) {
    const projectToken = configuration.mixpanel?.projectToken;
    const mixpanelConfig =
      isNonEmptyString(projectToken) && projectToken !== 'undefined'
        ? {
            projectToken,
            recordSessionsPercent: configuration.mixpanel?.recordSessionsPercent,
            useSimplifiedIdMerge: configuration.mixpanel?.useSimplifiedIdMerge,
          }
        : undefined;

    await setupAnalyticsAdapter(configuration.eventPrefix, configuration.apiKey, mixpanelConfig);
  }
});
